import { useLocation } from "react-router-dom"
import AssetDocuments from "./AssetDocuments"

export default function AssetDocumentsWithRefresh() {

    // See: https://github.com/remix-run/react-router/issues/7416
    const location = useLocation()
    console.log('AssetDocumentsWithRefresh location', location)
    return (
        <AssetDocuments key={location.key} />
    )
}